import { from } from "linq";
import React, { FC, useState } from "react";
import { Button, ButtonToolbar } from "react-bootstrap";
import StorageHelper from "../../utils/StorageHelper";
import { HttpMethods, WebSites } from "../../utils/Defaults";
import ApiAsync from "../../utils/ApiAsync";
import Global from "../../utils/Global";
import { Dialog, DialogFooter, DialogType } from "office-ui-fabric-react";
import IKeyText from "../../model/app/IKeyText";

type Props = any;
type State = any;

const CacheScreen: FC<Props> = (props: Props) => {
	const [state, setState] = useState<State>({
		showInfoDialog: false,
		dialogMessage: "",
	});

	const clearCache = async (): Promise<any | undefined> => {
		let baseUrl =
			from<IKeyText>(StorageHelper.getWebsites())
				.toArray()
				.filter((x) => x.key === WebSites.gate)[0].text + "Cache/RemoveBatch";
		//let baseUrl = "http://localhost:5005/Cache/RemoveBatch";
		try {
			const apiRes = await ApiAsync.run<any>(
				baseUrl,
				HttpMethods.delete,
				Global.getConfiguration().redisCahceKeys
			);
			return apiRes;
		} catch (error: any) {
			if (error) {
				showInfoDialog(error.message);
			}
		}
	};

	const showInfoDialog = (message: string = "") => {
		return setState((prevState) => {
			return {
				...prevState,
				showInfoDialog: true,
				dialogMessage: message,
			};
		});
	};

	const closeInfoDialog = () => {
		return setState((prevState) => {
			return {
				...prevState,
				showInfoDialog: false,
			};
		});
	};

	const renderInfoDialog = (): JSX.Element => {
		return (
			<>
				<Dialog
					hidden={!state.showInfoDialog}
					onDismiss={closeInfoDialog}
					dialogContentProps={{
						type: DialogType.normal,
						title: "Info",
						subText: state.dialogMessage ?? "n/a",
					}}
					modalProps={{
						isBlocking: true,
						containerClassName: "ms-dialogMainOverride",
					}}
				>
					<DialogFooter>
						<Button variant="info" onClick={closeInfoDialog}>
							Ok
						</Button>
					</DialogFooter>
				</Dialog>
			</>
		);
	};

	const renderMain = (): JSX.Element => {
		const ctrl = (
			<>
				<ButtonToolbar
					style={{
						marginBottom: "12px",
					}}
				>
					<Button
						style={{ backgroundColor: "red" }}
						onClick={async () => {
							var res = await clearCache();
							if (res) {
								return showInfoDialog("Cache cleared successfully!");
							}
							return;
						}}
					>
						Clear cache
					</Button>
				</ButtonToolbar>

				<div>{renderInfoDialog()}</div>
			</>
		);
		return ctrl;
	};

	return renderMain();
};

export default CacheScreen;
